/* istanbul ignore file reason: TODO: tests skipped due to release */
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MediaStreamService {
  private _stream: MediaStream;

  get stream() {
    return this._stream;
  }

  setStream(stream: MediaStream) {
    this._stream = stream;
  }

  stopStreaming() {
    this._stream.getVideoTracks().forEach(track => track.stop());
  }
}
